<div class="feedback-content-container">
  <div style="padding-top: 100px">
    <img
      [(src)]="env['logo_paths']['loginPagePic']"
      class="login-logo"
      alt="Login logo"
    />
  </div>
  <div class="login-form-div">
    <h4>Your feedback is important to us! Please share your thoughts below:</h4>
  </div>

  <form
    fxLayout="column"
    [formGroup]="feedbackFormGroup"
    style="display: flex; flex-direction: column; width: 30%"
  >
    <mat-form-field>
      <mat-label>Select a tool</mat-label>

      <mat-select formControlName="tool_id" required>
        @for (group of toolListWithModule; track group.module) {
          <mat-optgroup [label]="group.module">
            @for (tool of group.tools; track tool.id) {
              <mat-option [value]="tool.id" style="padding-left: 30px"
                >{{ tool.title }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
    </mat-form-field>
    <mat-error
      *ngIf="
        feedbackFormGroup.get('tool_id')?.invalid &&
        feedbackFormGroup.get('tool_id')?.touched
      "
      >Please select a tool.</mat-error
    >

    <mat-form-field>
      <mat-label>Your feedback or suggestion</mat-label>
      <textarea
        matInput
        required
        formControlName="feedback"
        [rows]="10"
      ></textarea>
    </mat-form-field>

    <mat-error
      *ngIf="
        feedbackFormGroup.get('feedback')?.invalid &&
        feedbackFormGroup.get('feedback')?.touched
      "
      >Please provide your feedback or suggestion</mat-error
    >

    <button
      style="width: 100%; color: white"
      [style.backgroundColor]="env['colors']['primary']"
      class="submitButton"
      type="submit"
      (click)="submitFeedback()"
      [disabled]="!feedbackFormGroup.valid"
      mat-raised-button
    >
      Submit
    </button>
  </form>
</div>
